var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'form-check',
    {
      'form-check-inline': _vm.inline,
      'is-disabled': _vm.disabled,
    }
  ]},[_c('label',{staticClass:"form-check-label"},[_c('input',_vm._b({staticClass:"form-check-input",attrs:{"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.radioValue,"checked":_vm.isChecked},on:{"change":_vm.handleChange}},'input',_vm.$attrs,false)),_vm._t("default"),(!_vm.$slots.default)?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }